(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LoaderGlyph", [], factory);
	else if(typeof exports === 'object')
		exports["LoaderGlyph"] = factory();
	else
		root["LoaderGlyph"] = factory();
})(this, function() {
return 